import { render, staticRenderFns } from "./mark-as-spam.vue?vue&type=template&id=aeb614a2&"
import script from "./mark-as-spam.vue?vue&type=script&lang=js&"
export * from "./mark-as-spam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports